import {
  Button,
  ConfigWrapper,
  DesktopLayoutBoxed,
} from '@kanda-libs/ks-design-library';

import { BacsPaymentForm, Copyright, JobSidebar } from 'components';
import CardContent from 'components/CardContent';
import useHelpModal from 'components/HelpModal/useHelpModal';

import useDekstop from './useDesktop';

import CantFindBankButton from '../components/CantFindBankButton';
import { PayByBacsPropsHook } from '../usePayByBacsProps';

const DesktopBacs: React.FunctionComponent<PayByBacsPropsHook> = function (
  props,
) {
  const { onClick } = useDekstop();
  const { showHelpModal } = useHelpModal();
  return (
    <ConfigWrapper sidebar={JobSidebar}>
      <DesktopLayoutBoxed
        help={showHelpModal}
        backgroundLines
        sidebar
        options={[]}
        layoutFooter={<Copyright />}
      >
        <CardContent>
          <>
            <Button.Icon
              id="ob-close"
              className="absolute top-8 right-8"
              icon="close"
              onClick={onClick}
            />
            <div className="flex flex-col">
              <BacsPaymentForm {...props} showHeading />
              <CantFindBankButton />
            </div>
          </>
        </CardContent>
      </DesktopLayoutBoxed>
    </ConfigWrapper>
  );
};

export default DesktopBacs;
